import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { ServicePortalRssFeedItem } from './ServicePortalRssFeedItem';
import { ServicePortalRssFeedProps, Item, Result } from './types';

export const ServicePortalRssFeed = (props: ServicePortalRssFeedProps) => {
  const { descriptiveText, displayOption, heading, feed, numberOfItemsToShow, servicePortalUrl } = props;

  const Items = (props: { currentItems: Item[] }) => {
    const { currentItems } = props;

    return (
      <>
        {currentItems &&
          currentItems.map((item) => (
            <ServicePortalRssFeedItem
              key={item.id}
              item={item}
              displayOption={displayOption}
              servicePortalUrl={servicePortalUrl}
            />
          ))}
      </>
    );
  };

  const PaginatedItems = (props: { feed: Result; itemsPerPage: number }) => {
    const [currentItems, setCurrentItems] = useState<Item[]>(null);
    const [pageCount, setPageCount] = useState<number>(0);
    const [itemOffset, setItemOffset] = useState<number>(0);

    const { itemsPerPage } = props;

    useEffect(() => {
      const endOffset = itemOffset + itemsPerPage;
      setCurrentItems(feed.concatenatedOutages.slice(itemOffset, endOffset));
      setPageCount(Math.ceil(feed.concatenatedOutages.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % feed.concatenatedOutages.length;
      setItemOffset(newOffset);
    };

    if (feed.concatenatedOutages.length <= numberOfItemsToShow) return <Items currentItems={currentItems} />;

    return (
      <>
      <div className='vgr-serviceportal-feed__container'>
        <Items currentItems={currentItems} />
        {displayOption.tag == 'OneThirdWidth' ? (
          <div className='search-result__pagination'>
          <ReactPaginate
            nextLabel={next}
            onPageChange={handlePageClick}
            pageRangeDisplayed={1}
            marginPagesDisplayed={1}
            pageCount={pageCount}
            previousLabel={previous}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination pagination-one-third-width"
            activeClassName="active"
          />
          </div>
        ) : (
          <div className='search-result__pagination'>
          <ReactPaginate
            nextLabel={next}
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            previousLabel={previous}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination pagination-one-third-width"
            activeClassName="active"
          />
          </div>
        )}
          </div>
      </>
    
    );
  };

  return (
    <div className="rssfeed block__generic-body" data-index-exclude="">
      <div className="vgr-itemlist vgr-serviceportal-feed">
        <section aria-label="Driftinformation IT" className="vgr-serviceportal-feed__head">
          <div className="list-block__heading block__header vgr-serviceportal-feed__heading">
            {alert}
            <h2 className="">{heading}</h2>
          </div>
          {descriptiveText !== null && (
          <div className="vgr-serviceportal-feed__sub-head">          
              <h3
                className="vgr-serviceportal-feed__sub-heading vgr-listitem"
                dangerouslySetInnerHTML={{ __html: descriptiveText }}
              />           
          </div>
           )}
        </section>
        <div className="vgr-serviceportal-feed__body">
          {feed !== null && feed.concatenatedOutages != null && feed.concatenatedOutages.length !== 0 ? (
            <PaginatedItems feed={feed} itemsPerPage={numberOfItemsToShow} />
          ) : (
            <article
              className={`vgr-serviceportal-feed__no-item ${feed === null || feed.concatenatedOutages == null ? "vgr-serviceportal-feed__error-message" : "vgr-serviceportal-feed__info-message"
                }`}
            >
              <div className='vgr-serviceportal-feed__svg'>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                  <g clipPath="url(#clip0_5941_131314)">
                    <path d="M12.5 25C15.8152 25 18.9946 23.683 21.3388 21.3388C23.683 18.9946 25 15.8152 25 12.5C25 9.18479 23.683 6.00537 21.3388 3.66117C18.9946 1.31696 15.8152 0 12.5 0C9.18479 0 6.00537 1.31696 3.66117 3.66117C1.31696 6.00537 0 9.18479 0 12.5C0 15.8152 1.31696 18.9946 3.66117 21.3388C6.00537 23.683 9.18479 25 12.5 25ZM10.5469 16.4062H11.7188V13.2812H10.5469C9.89746 13.2812 9.375 12.7588 9.375 12.1094C9.375 11.46 9.89746 10.9375 10.5469 10.9375H12.8906C13.54 10.9375 14.0625 11.46 14.0625 12.1094V16.4062H14.4531C15.1025 16.4062 15.625 16.9287 15.625 17.5781C15.625 18.2275 15.1025 18.75 14.4531 18.75H10.5469C9.89746 18.75 9.375 18.2275 9.375 17.5781C9.375 16.9287 9.89746 16.4062 10.5469 16.4062ZM12.5 6.25C12.9144 6.25 13.3118 6.41462 13.6049 6.70765C13.8979 7.00067 14.0625 7.3981 14.0625 7.8125C14.0625 8.2269 13.8979 8.62433 13.6049 8.91735C13.3118 9.21038 12.9144 9.375 12.5 9.375C12.0856 9.375 11.6882 9.21038 11.3951 8.91735C11.1021 8.62433 10.9375 8.2269 10.9375 7.8125C10.9375 7.3981 11.1021 7.00067 11.3951 6.70765C11.6882 6.41462 12.0856 6.25 12.5 6.25Z" fill="#8D4E18" />
                  </g>
                  <defs>
                    <clipPath id="clip0_5941_131314">
                      <rect width="25" height="25" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h3 className="vgr-serviceportal-feed__no-hits">
                {feed === null || feed.concatenatedOutages == null ? (
                  <>
                    <strong>Just nu kan vi inte hämta information från serviceportalen.</strong>
                    <p>  På grund av tekniska problem kan inte driftinformationen hämtas från serviceportalen.
                      Under tiden kan du <span> </span>
                      <a href="https://insidan.vgregion.se/driftinforeserv/">hitta tillfällig driftinformation här</a>.</p>

                  </>
                ) : (
                  "Just nu inga störningar eller planerade avbrott."
                )}
              </h3>
            </article>
          )}
        </div>


        <footer className="vgr-serviceportal-feed__footer block__row ">
          <a href={servicePortalUrl}>Visa driftinformation i VGR serviceportal</a>
        </footer>
      </div>
    </div>
  );
};

const alert = (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <g clipPath="url(#clip0_12307_4763)">
      <path d="M0.781327 25C0.578202 25 0.380286 24.9219 0.229244 24.7708C-0.00513114 24.5365 -0.0676311 24.1823 0.0782022 23.8802L3.10945 17.5104C2.14591 15.8281 1.61466 13.9271 1.56779 11.9844C1.5157 9.89583 2.02612 7.83333 3.04174 6.01042C4.05737 4.1875 5.54174 2.66667 7.33862 1.60937C9.13029 0.557292 11.1772 0 13.2605 0C13.2709 0 13.2865 0 13.297 0C15.0938 0 16.8907 0.421875 18.5001 1.22396C20.1147 2.02604 21.547 3.21354 22.6355 4.65104C23.724 6.08854 24.474 7.79167 24.8074 9.5625C25.1407 11.3385 25.0522 13.1927 24.5574 14.9271C24.0626 16.6615 23.1615 18.2865 21.9428 19.6198C20.7292 20.9531 19.1928 22 17.5105 22.651C15.8282 23.3021 13.9897 23.5573 12.1928 23.3854C10.5417 23.2292 8.92195 22.7135 7.47924 21.8906L1.11987 24.9219C1.01049 24.974 0.895911 25 0.781327 25ZM13.2553 1.5625C11.4532 1.5625 9.68237 2.04687 8.12508 2.95833C6.56779 3.875 5.28133 5.19271 4.40112 6.77083C3.52091 8.34896 3.08341 10.1406 3.12508 11.9479C3.16674 13.7552 3.69799 15.5208 4.65112 17.0573C4.79174 17.2812 4.80737 17.5625 4.69279 17.8073L2.43237 22.5625L7.18237 20.2969C7.42195 20.1823 7.7032 20.1979 7.93237 20.3385C9.26049 21.1667 10.7813 21.6771 12.3386 21.8281C13.8959 21.974 15.4897 21.7552 16.948 21.1927C18.4063 20.6302 19.7345 19.7188 20.7865 18.5677C21.8386 17.4115 22.6251 16.0052 23.0522 14.5C23.4792 12.9948 23.5522 11.3854 23.2657 9.84896C22.9792 8.3125 22.3282 6.83854 21.3855 5.59375C20.4428 4.34375 19.2032 3.31771 17.8022 2.625C16.4063 1.93229 14.849 1.56771 13.2917 1.56771C13.2865 1.56771 13.2761 1.56771 13.2709 1.56771H13.2553V1.5625Z" fill="black" />
      <path d="M15.625 17.1875H14.8437C14.2187 17.1875 13.6302 16.9427 13.1875 16.5C12.7448 16.0573 12.5 15.4687 12.5 14.8437V10.9375H11.7188C11.2865 10.9375 10.9375 10.5885 10.9375 10.1562C10.9375 9.72396 11.2865 9.375 11.7188 9.375H12.5C12.9167 9.375 13.3073 9.53646 13.6042 9.83333C13.901 10.1302 14.0625 10.5208 14.0625 10.9375V14.8437C14.0625 15.0521 14.1458 15.25 14.2917 15.3958C14.4375 15.5417 14.6354 15.625 14.8437 15.625H15.625C16.0573 15.625 16.4062 15.974 16.4062 16.4062C16.4062 16.8385 16.0573 17.1875 15.625 17.1875Z" fill="black" />
      <path d="M12.8906 7.8125C12.2448 7.8125 11.7188 7.28646 11.7188 6.64062C11.7188 5.99479 12.2448 5.46875 12.8906 5.46875V7.8125Z" fill="black" />
      <path d="M12.8906 7.8125V5.46875C13.5365 5.46875 14.0625 5.99479 14.0625 6.64062C14.0625 7.28646 13.5365 7.8125 12.8906 7.8125Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_12307_4763">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const next = (
  <svg
    id="alert"
    xmlns="http://www.w3.org/2000/svg"
    height="18"
    width="18"
    aria-hidden="true"
    focusable="false"
    className="svg-next">
    <use href="#streamline-arrow" />
  </svg>
);

const previous = (
  <svg
    id="alert"
    xmlns="http://www.w3.org/2000/svg"
    height="18"
    width="18"
    aria-hidden="true"
    focusable="false"
    className="svg-prev">
    <use href="#streamline-arrow" />
  </svg>
);
